// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Amplify } from '@aws-amplify/core';
import { remove as removeInternal } from './internal/remove';
export function remove(input) {
    return removeInternal(Amplify, input);
}
